module.exports = __webpack_public_path__ + "img/cl.d244e47f.svg";